import { chatActionModalReducer } from './chatActionModal';
import { chatCustomActionModalReducer } from './chatCustomActionModal';
import { chatImagesReducer } from './chatImages';
import { chatListReducer } from './chatList';
import { chatOperationsReducer } from './chatOperations';
import { chatWindowReducer } from './chatWindow';
import { chatbotReducer } from './chatbot';
import { chatbotFiltersModalReducer } from './chatbotFiltersModal';
import { contentFullscreenReducer } from './contentFullscreen';
import { errorPageReducer } from './errorPage';
import { feedbackChatbotModalReducer } from './feedbackChatbotModal';
import { firstMessageReducer } from './firstMessage';
import { hintQuestionsReducer } from './hintQuestions';
import { internetStatusReducer } from './internetStatus';
import { masterFiltersReducer } from './masterFilters';
import { messagesReducer } from './messages';
import { mobileSideReducer } from './mobileSide';
import { offersForSelectionReducer } from './offersForSelection';
import { openedChatsReducer } from './openedChats';
import { routeReducer } from './route';
import { subAgentsReducer } from './subAgents';
import { unreadMessagesCountReducer } from './unreadMessagesCount';
import { uploadFilesReducer } from './uploadFiles';
import { userCardReducer } from './userCard';
import { usersStatusReducer } from './usersStatus';
import { IAppStore } from '../store/createAppStore';

export function attachReducers(store: IAppStore) {
  store.addReducer(internetStatusReducer);
  store.addReducer(errorPageReducer);
  store.addReducer(mobileSideReducer);
  store.addReducer(chatListReducer);
  store.addReducer(routeReducer);
  store.addReducer(openedChatsReducer);
  store.addReducer(messagesReducer);
  store.addReducer(firstMessageReducer);
  store.addReducer(chatOperationsReducer);
  store.addReducer(contentFullscreenReducer);
  store.addReducer(uploadFilesReducer);
  store.addReducer(chatActionModalReducer);
  store.addReducer(feedbackChatbotModalReducer);
  store.addReducer(chatbotReducer);
  store.addReducer(chatbotFiltersModalReducer);
  store.addReducer(chatWindowReducer);
  store.addReducer(usersStatusReducer);
  store.addReducer(userCardReducer);
  store.addReducer(chatImagesReducer);
  store.addReducer(hintQuestionsReducer);
  store.addReducer(chatCustomActionModalReducer);
  store.addReducer(offersForSelectionReducer);
  store.addReducer(masterFiltersReducer);
  store.addReducer(subAgentsReducer);
  store.addReducer(unreadMessagesCountReducer);
}
